export default __webpack_public_path__ + "static/media/kenya.130d55af.png";